import { ErrorMessageConstant } from '@utility/constants/common';

/* Every `code` the mapping routes answer with (EN-4496 contract), in words. */
export const MAPPING_ERROR_MESSAGES: Record<string, string> = {
  INVALID_BODY:
    'The mapping request was not valid. Reload the page and try again.',
  LISTING_NOT_FOUND: 'This listing no longer exists. Reload the list.',
  ALREADY_MAPPED: 'This listing is already mapped. Reload the list.',
  SKU_TAKEN: 'An item with this SKU already exists.',
  ITEM_NOT_FOUND: 'That catalog item no longer exists. Pick another one.',
  EXCLUDED:
    'This listing was excluded on purpose. Reload the list and map it again to override that.',
  NON_INVENTORY:
    'This listing is not an inventory item, so it cannot be mapped.',
  DELISTED: 'This listing is delisted, so it cannot be mapped.',
  ITEM_ARCHIVED: 'That catalog item is archived. Pick another one.',
  ACCOUNT_NOT_ON_PLATFORM: 'This account is not set up on the platform yet.',
  CATALOG_WRITER_NOT_CONFIGURED:
    'Saving mappings is not configured yet. Contact support.',
  REFRESH_TOO_SOON:
    'Suggestions were checked less than a minute ago. Try again in a minute.',
  CATALOG_DB_UNAVAILABLE:
    'The catalog is temporarily unavailable. Try again in a moment.',
};

const SKU_TAKEN = 'SKU_TAKEN';

/**
 * The item a SKU_TAKEN answer names: the API sends it as `details.itemId`,
 * which BaseServiceV2 keeps on the rejected error.
 */
export function takenItemId(error: unknown): string | undefined {
  const { code, details } = (error ?? {}) as {
    code?: string;
    details?: { itemId?: unknown } | string;
  };
  const id = typeof details === 'object' ? details?.itemId : undefined;

  return code === SKU_TAKEN && typeof id === 'string' && id ? id : undefined;
}

/** The words for a failed mapping call; the API's own text, then a generic one, when the code is unknown. `sku` is the one a create-item call sent. */
export function mappingErrorMessage(error: unknown, sku?: string): string {
  const { code, error: text } = (error ?? {}) as {
    code?: string;
    error?: unknown;
  };

  if (code === SKU_TAKEN && sku) {
    return `An item with SKU ${sku} already exists`;
  }

  return (
    (code && MAPPING_ERROR_MESSAGES[code]) ||
    (typeof text === 'string' && text) ||
    ErrorMessageConstant.defaultAPIError
  );
}
